import * as React from "react";

function SvgIcons8IosLogo(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#eceff1"
        d="M16 42h16c5.523 0 10-4.477 10-10V16c0-5.523-4.477-10-10-10H16C10.477 6 6 10.477 6 16v16c0 5.523 4.477 10 10 10z"
      />
      <path
        fill="#ffc107"
        d="M12.783 17.974a.762.762 0 100 1.524.762.762 0 100-1.524z"
      />
      <path
        fill="#ff5722"
        d="M15.982 21.81l1.444-.61c.68-1.22 1.835-1.927 3.332-1.927.34 0 .659.043.962.113l1.372-.579a5.213 5.213 0 00-2.334-.526c-2.39 0-4.095 1.313-4.776 3.529zm-2.685 1.134v-1.569h-1.024v2.002z"
      />
      <path
        fill="#f44336"
        d="M13.297 25.733v-2.789l-1.024.433v2.788zm3.445-1.585c0-1.169.246-2.163.684-2.948l-1.444.61a7.932 7.932 0 00-.333 2.338c0 .201.028.382.04.574l1.062-.449c-.001-.043-.009-.081-.009-.125zM30.421 18.5a4.017 4.017 0 00-.774.327l.774-.327zm-7.329.307l-1.372.579c1.027.237 1.828.863 2.35 1.796l1.022-.432a4.5 4.5 0 00-2-1.943z"
      />
      <path
        fill="#e91e63"
        d="M13.297 28.521v-2.788l-1.024.432v2.788zM30.421 18.5l-.774.327c-.983.547-1.577 1.464-1.577 2.58 0 .302.046.571.117.825l1.032-.436a1.664 1.664 0 01-.056-.42c0-1.227 1.117-2.117 2.734-2.117.796 0 1.467.213 1.958.579l1.048-.443c-.694-.684-1.735-1.113-2.974-1.113a5.085 5.085 0 00-1.508.218zM16.75 24.274l-1.062.449c.059.959.26 1.811.597 2.536l1.004-.424c-.335-.714-.523-1.575-.539-2.561zm8.342-3.523l-1.022.432c.381.682.603 1.532.658 2.51l1.061-.448c-.094-.948-.322-1.793-.697-2.494z"
      />
      <path
        fill="#9c27b0"
        d="M25.609 26.108a8.222 8.222 0 00.242-1.96c0-.316-.033-.609-.063-.904l-1.061.448c.009.153.03.296.03.456 0 .968-.177 1.809-.481 2.523l1.333-.563zm-8.319.726l-1.004.424c.408.879 1.008 1.568 1.777 2.038l1.258-.531c-.901-.338-1.594-1.001-2.031-1.931zm-3.993 1.687l-1.024.432v.836h1.024zm15.923-6.726l-1.032.436c.245.866.915 1.471 2.129 1.889l1.6-.676-.338-.085c-1.457-.364-2.173-.832-2.359-1.564zm5.499-.522h1.078c-.05-.731-.379-1.373-.893-1.879l-1.048.443c.472.352.779.847.863 1.436z"
      />
      <path
        fill="#3f51b5"
        d="M25.609 26.108l-1.333.563c-.629 1.476-1.85 2.36-3.519 2.36a4.029 4.029 0 01-1.437-.267l-1.258.531c.752.459 1.648.728 2.695.728 2.543 0 4.262-1.482 4.852-3.915zm3.219.751H27.75c.026.368.127.705.264 1.021l.989-.418a2.068 2.068 0 01-.175-.603zm3.867-3.218l-.779-.196-1.6.676c.234.081.487.156.762.224l1.289.328c.714.176 1.257.399 1.659.669l1.205-.509c-.528-.515-1.353-.899-2.536-1.192z"
      />
      <path
        fill="#03a9f4"
        d="M29.003 27.463l-.989.418c.377.87 1.139 1.531 2.166 1.873l1.692-.714c-1.379-.033-2.457-.644-2.869-1.577zm6.911-.13a3.32 3.32 0 00.063-.598c0-.784-.234-1.404-.745-1.902l-1.205.509c.579.39.856.883.856 1.51 0 .393-.131.75-.348 1.063l1.379-.582z"
      />
      <path
        fill="#009688"
        d="M35.914 27.333l-1.379.583c-.472.682-1.394 1.132-2.55 1.132-.039 0-.074-.006-.112-.007l-1.692.714a5.398 5.398 0 001.71.269c2.207-.001 3.724-1.06 4.023-2.691z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8IosLogo);
